export const navbar = [
  {
    id: 1,
    menu: "How We Different",
    alt: "How We Different",
    href: "#different",
  },
  {
    id: 2,
    menu: "Our Services",
    alt: "Our Services",
    href: "#services",
  },
  {
    id: 3,
    menu: "Portfolio",
    alt: "Portfolio",
    href: "#portfolio",
  },
  {
    id: 4,
    menu: "Testimonials",
    alt: "Testimonials",
    href: "#testimonials",
  },
  {
    id: 5,
    menu: "Blog",
    alt: "Blog",
    href: "#blogs",
  },
  {
    id: 6,
    menu: "About Us",
    alt: "About Us",
    href: "#story",
  },
];

// Different From Other Data

export const differentFromOther = [
  {
    heading: "Commitment to Excellence",
    paragraph:
      "It's the relentless pursuit of perfection, the unwavering drive to innovate, and the refusal to settle for anything less than extraordinary.",
  },
  {
    heading: "Cost Effective Development",
    paragraph:
      "Maximizing value without compromising quality, efficiency, or innovation. It's about strategic resource allocation, leveraging technology, and streamlining processes to achieve optimal outcomes within budget constraints.",
  },
  {
    heading: "Responsible and Trustworthy",
    paragraph:
      "By upholding these principles, we create a foundation of credibility and reliability that defines our character and drives our success.",
  },
  {
    heading: "Transparent from start to finish",
    paragraph:
      "Open communication, clear processes, and honesty at every stage. It's about fostering trust through sharing information, addressing concerns openly, and embracing accountability.",
  },
];

// Our Technologies Data

export const ourTechnologyBtns = [
  {
    _id: "65ae1de32689c9d4fe5c2b4c",
    value: "frontend",
  },
  {
    _id: "65ae1e082689c9d4fe5c2baf",
    value: "backend",
  },
  {
    _id: "65ae200d2689c9d4fe5c2e1a",
    value: "database",
  },
  {
    _id: "65ae20212689c9d4fe5c2e29",
    value: "testing",
  },
  {
    _id: "65ae34ec2689c9d4fe5c2fd1",
    value: "cms",
  },
];

export const ourTechnologies: any = [
  {
    _id: "65ae4446467d0934811cedf1",
    icon: "https://i.ibb.co/8bgtpL7/React-icon-1.png",
    title: "React JS",
    category: "frontend",
  },
  {
    _id: "65ae4461467d0934811cf72c",
    icon: "https://i.ibb.co/r6ZJS76/javascript.png",
    title: "JavaScript",
    category: "frontend",
  },
  {
    _id: "65ae4483467d0934811d013a",
    icon: "https://i.ibb.co/Dp7nw0L/typescript.png",
    title: "TypeScript",
    category: "frontend",
  },
  {
    _id: "65ae44a0467d0934811d055e",
    icon: "https://i.ibb.co/GJgyXvR/html.png",
    title: "HTML 5",
    category: "frontend",
  },
  {
    _id: "65ae44b4467d0934811d0c8b",
    icon: "https://i.ibb.co/zV6xJrR/next.png",
    title: "Next JS",
    category: "frontend",
  },
  {
    _id: "65ae456e467d0934811d6591",
    icon: "https://i.ibb.co/3mBGfgr/nodejs.png",
    title: "Node JS",
    category: "backend",
  },
  {
    _id: "65ae457f467d0934811d662f",
    icon: "https://i.ibb.co/G7VDfzj/express.png",
    title: "Express JS",
    category: "backend",
  },
  {
    _id: "65ae4595467d0934811d671d",
    icon: "https://i.ibb.co/9WGWTxD/graphql.png",
    title: "GraphQL",
    category: "backend",
  },
  {
    _id: "65ae459f467d0934811d67c5",
    icon: "https://i.ibb.co/Y8trMXb/laravel.png",
    title: "Laravel",
    category: "backend",
  },
  {
    _id: "65ae45f6467d0934811d8f1b",
    icon: "https://i.ibb.co/FnLjrJG/mongodb.png",
    title: "MongoDB",
    category: "database",
  },
  {
    _id: "65ae4600467d0934811d9020",
    icon: "https://i.ibb.co/S5x3dd3/firebase.png",
    title: "Firebase",
    category: "database",
  },
  {
    _id: "65ae460e467d0934811d90d3",
    icon: "https://i.ibb.co/dQXhtBR/mysql.png",
    title: "MySQL",
    category: "database",
  },
  {
    _id: "65ae4697467d0934811dd0b4",
    icon: "https://i.ibb.co/85nVqKk/selenium.png",
    title: "Selenium",
    category: "testing",
  },
  {
    _id: "65ae46a6467d0934811dd26e",
    icon: "https://i.ibb.co/GM5vkjQ/postman.png",
    title: "Postman",
    category: "testing",
  },
  {
    _id: "65ae46b0467d0934811dd37e",
    icon: "https://i.ibb.co/t8ybHT2/playwright.png",
    title: "Playwright",
    category: "testing",
  },
  {
    _id: "65ae46b8467d0934811dd474",
    icon: "https://i.ibb.co/rbwD9Zp/jest.png",
    title: "Jest",
    category: "testing",
  },
  {
    _id: "65ae46fa467d0934811df195",
    icon: "https://i.ibb.co/60KHpT8/wordpress.png",
    title: "WordPress",
    category: "cms",
  },
  {
    _id: "65ae4707467d0934811df409",
    icon: "https://i.ibb.co/BqjGCm2/shopify.png",
    title: "Shopify",
    category: "cms",
  },
];

// Client Work Data

export const clientData = [
  {
    _id: "65e048e5b873cfc3926251d9",
    image: "https://i.ibb.co/ScHVrm3/istockphoto-1355051102-612x612.jpg",
    Name: "Paul Campbell",
    company: "UK",
    position: "Founder",
    description:
      "I highly recommend this team. They over-deliver on all their projects. I have now completed several design projects with them and my team is delighted with the results of affected works. Working with them has consistently exceeded our expectations, and I am confident in their ability to tackle any future projects with the same level of excellence.",
  },
  {
    _id: "65e04929b873cfc3926251ea",
    image: "https://i.ibb.co/qYRWwhk/istockphoto-1172720537-612x612.jpg",
    Name: "Kenny Perry",
    company: "UK",
    position: "Founder",
    description:
      "This was my first experience with Nexasoft Infotech IT Services was great! I received regular updates and he progressed quickly on the project. Their clear communication and dedication to meeting deadlines made the entire process smooth and efficient. I definitely recommend Nexasoft Infotech Team for their professionalism and quality of service. ",
  },
  {
    _id: "65e0495eb873cfc3926251f7",
    image: "https://i.ibb.co/Y3M6vwC/istockphoto-1336324740-612x612.jpg",
    Name: "Nikos Lin",
    company: "Greece",
    position: "Founder",
    description:
      "Nexasoft Infotech is a professional web development company. Excellent Creative at work and ideas. We are very happy to have an associate with a Nexasoft Infotech. Their dedication to delivering high-quality solutions and their commitment to client satisfaction make them an invaluable asset to any project.",
  },
  {
    _id: "65e04979b873cfc3926251fc",
    image: "https://i.ibb.co/BV8Pdt2/istockphoto-1362448780-612x612.jpg",
    Name: "Shreyansh",
    company: "India",
    position: "Founder",
    description:
      "I had a critical error and didn’t know what went wrong. The web developer who fixed my site worked quickly and efficiently, demonstrating an impressive level of expertise and problem-solving skills. Their prompt action and effective solutions helped turn a potentially disastrous situation into a positive outcome. I am grateful for their professionalism and swift assistance.",
  },
  {
    _id: "65e04996b873cfc392625201",
    image: "https://i.ibb.co/TrCmnfz/istockphoto-1132792394-612x612.jpg",
    Name: "Phillip",
    company: "France",
    position: "Founder",
    description:
      "The theme is awesome and the support is even better! They were always willing to help and answered very quickly. I also appreciated their screenshots which made it greatly facilitated the resolution of any issues I encountered. It's this level of support that truly sets them apart, and I highly recommend their services to anyone in need of reliable assistance.",
  },
  {
    _id: "65e049bbb873cfc392625206",
    image: "https://i.ibb.co/hcfhVGj/istockphoto-1312622474-612x612.jpg",
    Name: "Llia Poul",
    company: "UK",
    position: "Founder",
    description:
      "I’m glad to hear that you had such a positive experience working with this team! It sounds like they are not only talented APP Developers, but also great communicators and problem solvers. It's always refreshing to come across a team that excels not only in technical skills but also in customer service and collaboration. Their dedication to providing a seamless experience speaks volumes about their professionalism and commitment to client satisfaction.",
  },
  {
    _id: "65e049d5b873cfc39262520b",
    image:
      "https://i.ibb.co/BwxXLMX/360-F-636698674-Dro-Ch-Ej5e-Wm-Zia-ZOSDMnj8hc-Dqqw74-Fp.jpg",
    Name: "Monica Lin",
    company: "Canada",
    position: "Founder",
    description:
      "Their ability to complete the project quickly and smoothly is a testament to their efficiency and expertise in the field of web development. It’s always reassuring to work with a team that not only understands the technical aspects but also values timeliness and quality.",
  },
  {
    _id: "65e04a2fb873cfc39262525e",
    image: "https://i.ibb.co/NZ2vPnj/istockphoto-851628528-612x612.jpg",
    Name: "Ahmed",
    company: "Kuwait",
    position: "Founder",
    description:
      "Their expertise and attention to detail helped us create an app that exceeded our expectations. Their communication and collaboration skills were also top-notch, making the entire development process smooth and efficient. It was evident that they truly cared about understanding our needs and delivering a product that aligned perfectly with our vision. Working with them was not only productive but also enjoyable, and I would highly recommend their services to anyone seeking high-quality app development coupled with exceptional customer service.",
  },
  {
    _id: "65e04a4fb873cfc392625263",
    image: "https://i.ibb.co/B2TJqBF/istockphoto-911029266-612x612.jpg",
    Name: "Cady ",
    company: "Malaysia",
    position: "Founder",
    description:
      "It’s great to see that I’m happy with the work done by the Unity tem. Their ability for both Android and iOS platforms demonstrates their versatility and proficiency in mobile app development. This dual capability not only streamlines the development process but also ensures a consistent and high-quality user experience across different platforms.",
  },
  {
    _id: "65e04a64b873cfc392625268",
    image:
      "https://i.ibb.co/TRFb02M/young-man-bench-with-hands-together-23-2148322113.jpg",
    Name: "Tim",
    company: "USA",
    position: "Founder",
    description:
      "I had the pleasure of working with the team on an AR app project using unity, and I must say, I was thoroughly impressed with their expertise and professionalism. Their in-depth knowledge of Unity and augmented reality technologies was evident throughout the project, and they consistently delivered high-quality results. Moreover, their professionalism and commitment to meeting deadlines ensured a smooth and successful collaboration.",
  },
];

// Footer Data

export const socialLinkData = [
  {
    id: 1,
    icon: "/Footer_Images/whatsapp.svg",
    text: "whatsapp",
    href: "https://wa.me/8460720816",
  },
  {
    id: 2,
    icon: "/Footer_Images/instagram.svg",
    text: "instagram",
    href: "https://www.instagram.com/nexasoftinfotech/",
  },
  {
    id: 3,
    icon: "/Footer_Images/linkedin.svg",
    text: "linkedin",
    href: "https://www.linkedin.com/company/93227934/admin/feed/posts/",
  },
];
export const footerLinkData = {
  quickLinks: [
    {
      id: 1,
      linkName: "Testimonials",
      href: "#testimonials",
    },
    {
      id: 2,
      linkName: "How we Different",
      href: "#different",
    },
  ],
  information: [
    {
      id: 1,
      linkName: "About",
      href: "#story",
    },
    {
      id: 2,
      linkName: "Contact",
      href: "#contact",
    },
    {
      id: 3,
      linkName: "Blogs",
      href: "#blogs",
    },
  ],
  services: [
    {
      id: 1,
      linkName: "Web Development",
      href: "#services",
    },
    {
      id: 2,
      linkName: "Mobile App Development",
      href: "#services",
    },
    {
      id: 3,
      linkName: "Game Development",
      href: "#services",
    },

    {
      id: 5,
      linkName: "UI/UX Design",
      href: "#services",
    },
  ],
};

// Blogs Data

export const blogsData = [
  {
    _id: 1,
    image:
      "https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg",
    title: "Modern Web Development: React, Next.js, and Serverless Architecture",
    description:
      "<p>Web development has evolved dramatically with modern frameworks and architectures revolutionizing how we build applications. In this article, we explore the latest trends in web development, focusing on React, Next.js, and serverless architecture that are shaping the future of digital experiences.</p><p><br></p><p>React.js continues to dominate the frontend landscape with its component-based architecture, virtual DOM, and extensive ecosystem. Combined with Next.js, developers can build full-stack applications with server-side rendering (SSR), static site generation (SSG), and API routes. This powerful combination enables blazing-fast performance, improved SEO, and better user experiences across all devices.</p><p><br></p><p>Serverless architecture is transforming backend development by eliminating server management overhead. Platforms like AWS Lambda, Vercel, and Netlify Functions allow developers to build scalable applications that automatically scale based on demand. This approach reduces costs, improves performance, and enables faster deployment cycles with CI/CD pipelines.</p><p><br></p><p>Modern web development also emphasizes Progressive Web Apps (PWAs) that combine the best of web and mobile experiences. Features like offline functionality, push notifications, and app-like interfaces create seamless user experiences. Combined with modern optimization techniques like code splitting, lazy loading, and CDN integration, PWAs deliver native app-like performance.</p><p><br></p><p>TypeScript has become essential for large-scale applications, providing type safety, better IDE support, and improved code maintainability. Microservices architecture enables teams to build scalable, maintainable systems where each service can be developed, deployed, and scaled independently. API-first design ensures seamless integration between frontend and backend, enabling faster development cycles.</p><p><br></p><p>In conclusion, modern web development leverages cutting-edge technologies like React, Next.js, TypeScript, and serverless architecture to build scalable, performant, and maintainable applications. By adopting these modern practices, developers can create exceptional digital experiences that meet the demands of today's users while preparing for future technological advancements.</p>",
    tags: ["Web Development", "React", "Next.js", "Serverless"],
  },
  {
    _id: 2,
    image: "https://i.ibb.co/tBvbNgN/web-design-development-blog-2.jpg",
    title: "AI and Machine Learning Integration in Modern Software Development",
    description:
      "<p>Artificial Intelligence and Machine Learning are revolutionizing software development, enabling developers to build smarter, more intuitive applications. In this article, we explore how AI/ML integration is transforming modern software development practices and creating new possibilities for innovation.</p><p><br></p><p>AI-powered development tools are enhancing productivity and code quality. GitHub Copilot, powered by OpenAI's Codex, provides intelligent code suggestions and autocomplete features. AI-assisted debugging tools can identify bugs faster, suggest fixes, and even generate test cases. These tools are becoming essential for modern development workflows, reducing development time and improving code quality.</p><p><br></p><p>Machine Learning integration enables applications to learn from user behavior and adapt accordingly. Recommendation engines, predictive analytics, and personalization features are now standard in modern applications. Natural Language Processing (NLP) powers chatbots, voice assistants, and content analysis features. Computer Vision enables image recognition, object detection, and augmented reality experiences.</p><p><br></p><p>Cloud-based ML services from AWS, Google Cloud, and Azure make AI integration accessible to developers without deep ML expertise. Services like AWS SageMaker, Google Cloud AI Platform, and Azure Machine Learning provide pre-built models, APIs, and infrastructure for deploying ML solutions. This democratization of AI enables startups and enterprises alike to leverage powerful AI capabilities.</p><p><br></p><p>MLOps (Machine Learning Operations) practices are emerging to manage the ML lifecycle, similar to DevOps for traditional software. This includes version control for models, automated training pipelines, A/B testing, and continuous monitoring. Modern frameworks like TensorFlow, PyTorch, and scikit-learn provide powerful tools for building and deploying ML models.</p><p><br></p><p>In conclusion, AI and ML integration in software development is no longer a luxury but a necessity for competitive applications. From intelligent code assistants to predictive analytics and personalized user experiences, AI/ML technologies are transforming how we build and deploy software. By embracing these technologies, developers can create more intelligent, efficient, and user-centric applications that stand out in today's competitive market.</p>",
    tags: ["AI", "Machine Learning", "Software Development", "Technology"],
  },
  {
    _id: 3,
    image: "https://i.ibb.co/1z0r149/2653.jpg",
    title: "Cross-Platform Mobile Development: React Native vs Flutter in 2024",
    description:
      "<p>Cross-platform mobile development has become the preferred approach for businesses looking to reach both iOS and Android users efficiently. In this comprehensive guide, we compare React Native and Flutter, the two leading frameworks dominating the cross-platform development landscape in 2024.</p><p><br></p><p>React Native, developed by Meta (Facebook), leverages JavaScript and React to build native mobile applications. Its key advantages include a large developer community, extensive third-party libraries, hot reload for rapid development, and the ability to share code between web and mobile platforms. React Native apps have near-native performance and can access platform-specific APIs through native modules.</p><p><br></p><p>Flutter, Google's UI toolkit, uses Dart programming language and provides a complete framework for building natively compiled applications. Flutter's standout features include its own rendering engine (Skia), which ensures consistent UI across platforms, excellent performance with 60fps animations, and a rich set of pre-built widgets. Flutter's hot reload is faster than React Native's, and its single codebase approach reduces platform-specific bugs.</p><p><br></p><p>Performance comparison shows Flutter often has an edge due to its compiled nature and custom rendering engine, while React Native relies on JavaScript bridges that can cause performance bottlenecks. However, React Native's mature ecosystem and JavaScript familiarity make it easier to find developers and integrate with existing web codebases.</p><p><br></p><p>Both frameworks support modern development practices including state management (Redux, MobX for React Native; Provider, Bloc for Flutter), testing frameworks, CI/CD integration, and cloud deployment. The choice between them often depends on team expertise, project requirements, and long-term maintenance considerations.</p><p><br></p><p>In conclusion, both React Native and Flutter offer compelling solutions for cross-platform mobile development. React Native excels with its JavaScript ecosystem and web compatibility, while Flutter provides superior performance and UI consistency. The best choice depends on your specific project needs, team skills, and performance requirements. Both frameworks continue to evolve rapidly, making cross-platform development more efficient and powerful than ever before.</p>",
    tags: ["Mobile Development", "React Native", "Flutter", "Cross-Platform"],
  },
  {
    _id: 4,
    image: "https://i.ibb.co/YtSgF50/1697607088.jpg",
    title: "Cloud-Native Development and DevOps: Building Scalable Applications",
    description:
      "<p>Cloud-native development and DevOps practices have become essential for building scalable, resilient, and efficient applications in today's digital landscape. This article explores how modern development teams leverage cloud technologies and DevOps methodologies to deliver high-quality software faster.</p><p><br></p><p>Cloud-native architecture embraces microservices, containers, and orchestration to build applications designed for cloud environments. Docker containers package applications with all dependencies, ensuring consistency across development, testing, and production. Kubernetes orchestrates these containers, providing automatic scaling, load balancing, and self-healing capabilities. This approach enables applications to handle varying loads efficiently and recover from failures automatically.</p><p><br></p><p>DevOps practices bridge the gap between development and operations, enabling continuous integration and continuous deployment (CI/CD). Automated pipelines using tools like Jenkins, GitHub Actions, GitLab CI, and Azure DevOps automate testing, building, and deployment processes. Infrastructure as Code (IaC) with Terraform and CloudFormation allows teams to version control and automate infrastructure provisioning, reducing manual errors and ensuring consistency.</p><p><br></p><p>Cloud platforms like AWS, Azure, and Google Cloud provide managed services that eliminate infrastructure management overhead. Serverless computing with AWS Lambda, Azure Functions, and Cloud Functions enables developers to focus on code without managing servers. Managed databases, message queues, and caching services reduce operational complexity while providing high availability and scalability.</p><p><br></p><p>Monitoring and observability are crucial for cloud-native applications. Tools like Prometheus, Grafana, and Datadog provide real-time metrics, logging, and tracing capabilities. This enables teams to identify performance bottlenecks, track errors, and optimize resource usage. Cloud-native applications also implement health checks, circuit breakers, and graceful degradation to maintain service reliability.</p><p><br></p><p>Security in cloud-native development follows the principle of defense in depth. This includes container scanning, secret management, network policies, and regular security audits. Cloud providers offer built-in security features like identity and access management (IAM), encryption at rest and in transit, and DDoS protection. DevSecOps integrates security practices throughout the development lifecycle.</p><p><br></p><p>In conclusion, cloud-native development and DevOps practices enable teams to build scalable, resilient applications that can adapt to changing demands. By embracing containers, orchestration, CI/CD pipelines, and cloud services, organizations can accelerate development cycles, improve reliability, and reduce operational costs. These practices are no longer optional but essential for competitive software development in the modern era.</p>",
    tags: ["Cloud Computing", "DevOps", "Kubernetes", "Microservices"],
  },
  {
    _id: 5,
    image: "https://miro.medium.com/v2/0*VyoNi7yLm-ZcCPms",
    title: "Microservices Architecture and API-First Development: Modern Backend Strategies",
    description:
      "<p>Microservices architecture and API-first development have become fundamental patterns for building scalable, maintainable backend systems. This article explores how these modern architectural approaches enable teams to build robust, flexible applications that can evolve with business needs.</p><p><br></p><p>Microservices architecture breaks down monolithic applications into small, independent services that communicate through well-defined APIs. Each microservice owns its data, can be developed and deployed independently, and uses the most appropriate technology stack. This approach enables teams to scale services individually, deploy updates without affecting the entire system, and improve fault isolation. Popular frameworks like Spring Boot, Express.js, and FastAPI facilitate microservices development.</p><p><br></p><p>API-first development treats APIs as first-class citizens, designing them before implementation begins. This approach ensures consistent interfaces, enables parallel development between frontend and backend teams, and facilitates integration with third-party services. RESTful APIs remain popular, but GraphQL is gaining traction for its flexible querying capabilities. OpenAPI/Swagger specifications document APIs, enabling automatic code generation and testing tools.</p><p><br></p><p>Service communication in microservices architectures uses various patterns. Synchronous communication via HTTP/REST is common for request-response scenarios, while asynchronous messaging with RabbitMQ, Apache Kafka, or AWS SQS handles event-driven workflows. Service mesh technologies like Istio and Linkerd provide advanced features like load balancing, service discovery, and security policies across microservices.</p><p><br></p><p>API Gateway patterns centralize cross-cutting concerns like authentication, rate limiting, and request routing. Tools like Kong, AWS API Gateway, and Azure API Management provide these capabilities. GraphQL gateways aggregate multiple backend services, presenting a unified API to clients. This simplifies frontend development and reduces over-fetching of data.</p><p><br></p><p>Data management in microservices follows the database-per-service pattern, where each service has its own database. This ensures loose coupling but requires careful consideration of data consistency. Event sourcing and CQRS (Command Query Responsibility Segregation) patterns help maintain data consistency across services. Distributed transactions are avoided in favor of eventual consistency and saga patterns.</p><p><br></p><p>In conclusion, microservices architecture and API-first development represent the evolution of backend development toward more flexible, scalable systems. While these patterns introduce complexity in service coordination and data management, they provide significant benefits in terms of scalability, maintainability, and team autonomy. Organizations adopting these patterns must invest in proper tooling, monitoring, and DevOps practices to realize their full potential. The future of backend development lies in these distributed, API-driven architectures that enable rapid innovation and business agility.</p>",
    tags: ["Microservices", "API Development", "Backend Architecture", "Software Design"],
  },
];

// Services Data

export const androidData = [
  {
    id: 1,
    heading: "Cross-Platform Development",
    content:
      "We leverage React Native, Flutter, and Kotlin Multiplatform to build native-like apps for both Android and iOS from a single codebase, reducing development time and costs.",
  },
  {
    id: 2,
    heading: "Modern Architecture & Security",
    content:
      "Our apps follow MVVM, Clean Architecture patterns with Jetpack Compose, and implement advanced security features including biometric authentication, encryption, and secure API integration.",
  },
  {
    id: 3,
    heading: "Cloud Integration & Scalability",
    content:
      "We integrate Firebase, AWS Amplify, and cloud services for real-time data sync, push notifications, analytics, and scalable backend infrastructure to support millions of users.",
  },
];
export const webDevelopmentData = [
  {
    heading: "Modern Full-Stack Development",
    content:
      "We build scalable web applications using React, Next.js, Vue.js, Node.js, and TypeScript with serverless architecture, microservices, and API-first design for optimal performance and maintainability.",
  },
  {
    heading: "Cloud-Native & DevOps",
    content:
      "Our solutions are deployed on AWS, Azure, and GCP with Docker, Kubernetes, CI/CD pipelines, and automated testing to ensure rapid deployment and 99.9% uptime.",
  },
  {
    heading: "Progressive Web Apps & Performance",
    content:
      "We create PWAs with offline capabilities, push notifications, and lightning-fast load times using modern optimization techniques, CDN integration, and Core Web Vitals optimization.",
  },
];
export const gameDevelopmentData = [
  {
    heading: "Multi-Platform Game Development",
    content:
      "We develop games using Unity, Unreal Engine, and Godot for PC, mobile, console, and VR/AR platforms with cross-platform multiplayer capabilities and cloud save integration.",
  },
  {
    heading: "Advanced Graphics & AI",
    content:
      "Our games feature cutting-edge graphics with real-time rendering, shader programming, and AI-powered NPCs, procedural generation, and adaptive difficulty systems for immersive experiences.",
  },
  {
    heading: "Live Services & Monetization",
    content:
      "We implement live game services, analytics, in-app purchases, ads integration, and social features to maximize player engagement and revenue through data-driven strategies.",
  },
];
export const UiUxData = [
  {
    heading: "User-Centered Design & Research",
    content:
      "We conduct comprehensive user research, usability testing, and data-driven design decisions using Figma, Adobe XD, and modern design systems to create intuitive, accessible, and conversion-optimized interfaces.",
  },
  {
    heading: "Modern Design Systems & Prototyping",
    content:
      "We build scalable design systems with component libraries, interactive prototypes, and design tokens ensuring consistency across all platforms and enabling rapid development with design-to-code workflows.",
  },
  {
    heading: "Accessibility & Performance",
    content:
      "Our designs follow WCAG 2.1 AA standards, implement dark mode, responsive layouts, and optimize for Core Web Vitals to ensure inclusive, fast, and delightful user experiences across all devices.",
  },
];
export const servicesData = [
  {
    id: "ui-ux-design",
    mainTitle: "UI/UX",
    subTitle: "Design",
    imagePath: "/uiux.png",
    description:
      "UI/UX is the heart of any application. Our design team creates user-centered interfaces using modern design systems, comprehensive user research, and data-driven design decisions. We build scalable design systems with Figma and Adobe XD, ensure WCAG 2.1 AA accessibility compliance, optimize for performance and conversions, and deliver interactive prototypes that transform into pixel-perfect, responsive interfaces.",
    data: UiUxData,
  },
  {
    id: "mobile-app-development",
    mainTitle: "Mobile App",
    subTitle: "Development",
    imagePath: "appdev.png",
    description:
      "With over a decade of expertise, Nexasoft delivers cutting-edge mobile applications for iOS and Android using React Native, Flutter, Swift, Kotlin, and native development. We build scalable apps with modern architecture patterns (MVVM, Clean Architecture), integrate cloud services (Firebase, AWS), implement advanced security features, and ensure seamless user experiences across all devices.",
    data: androidData,
  },
  {
    id: "web-development",
    mainTitle: "Web",
    subTitle: "Development",
    imagePath: "/webdevelopment.png",
    description:
      "As a leading web development company, we build modern, scalable web applications using cutting-edge technologies like React.js, Next.js, Vue.js, Node.js, TypeScript, and serverless architectures. We create Progressive Web Apps (PWAs), implement microservices, deploy on cloud platforms (AWS, Azure, GCP), and ensure optimal performance with CI/CD pipelines and automated testing.",
    data: webDevelopmentData,
  },
  {
    id: "game-development",
    mainTitle: "Game",
    subTitle: "Development",
    imagePath: "gamedev.png",
    description:
      "Nexasoft is an acclaimed game development studio with highly talented developers skilled in Unity, Unreal Engine, and Godot. We create immersive games for mobile, PC, console, and VR/AR platforms with advanced graphics, AI-powered features, multiplayer capabilities, and live services. Our games feature cutting-edge technology, engaging gameplay mechanics, and monetization strategies that maximize player engagement and revenue.",
    data: gameDevelopmentData,
  },
];


export const technologiesOptions = [
  "React JS",
  "JavaScript",
  "TypeScript",
  "HTML 5",
  "Next JS",
  "Node JS",
  "Express JS",
  "GraphQL",
  "Laravel",
  "MongoDB",
  "Firebase",
  "MySQL",
  "Selenium",
  "Postman",
  "Playwright",
  "Jest",
  "WordPress",
  "Shopify",
];

// Portfolio Data
export const portfolioData = [
  {
    id: 1,
    title: "E-Commerce Platform",
    description: "A modern, scalable e-commerce platform built with React, Next.js, and Node.js. Features include real-time inventory management, secure payment integration, and advanced analytics dashboard.",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
    tags: ["React", "Next.js", "Node.js", "MongoDB"],
    category: "Web Development",
    year: "2025",
    liveUrl: "#",
    githubUrl: "#",
  },
  {
    id: 2,
    title: "Healthcare Management App",
    description: "A comprehensive mobile application for healthcare providers with patient management, appointment scheduling, and telemedicine capabilities. Built with React Native and Firebase.",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&h=600&fit=crop",
    tags: ["React Native", "Firebase", "TypeScript"],
    category: "Mobile App",
    year: "2024",
    liveUrl: "#",
    githubUrl: "#",
  },
  {
    id: 3,
    title: "AI-Powered Analytics Dashboard",
    description: "An intelligent analytics platform with machine learning capabilities for predictive insights. Features real-time data visualization, automated reporting, and AI-driven recommendations.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
    tags: ["Python", "React", "TensorFlow", "AWS"],
    category: "AI/ML",
    year: "2025",
    liveUrl: "#",
    githubUrl: "#",
  },
  {
    id: 4,
    title: "FinTech Payment Gateway",
    description: "A secure, high-performance payment processing system with multi-currency support, fraud detection, and real-time transaction monitoring. Built with microservices architecture.",
    image: "https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=800&h=600&fit=crop",
    tags: ["Node.js", "Kubernetes", "PostgreSQL", "Docker"],
    category: "Backend",
    year: "2023",
    liveUrl: "#",
    githubUrl: "#",
  },
  {
    id: 5,
    title: "Educational Learning Platform",
    description: "An interactive online learning platform with video streaming, live classes, progress tracking, and gamification features. Supports multiple languages and adaptive learning paths.",
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&h=600&fit=crop",
    tags: ["Vue.js", "Laravel", "WebRTC", "Redis"],
    category: "Web Development",
    year: "2025",
    liveUrl: "#",
    githubUrl: "#",
  },
  {
    id: 6,
    title: "IoT Smart Home System",
    description: "A comprehensive IoT solution for smart home automation with mobile app control, voice integration, energy monitoring, and security features. Built with React Native and AWS IoT.",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop",
    tags: ["React Native", "AWS IoT", "GraphQL", "MongoDB"],
    category: "IoT",
    year: "2024",
    liveUrl: "#",
    githubUrl: "#",
  },
];